import { columns, mobileColumns } from './Column';
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable';
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize';
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ReportFooter from '../../ReportsFooter/ReportFooter';

const SpecificAppUsersReportTable = ({
    DisplayDate,
    SpecificAppUsersReportData,
    handleColumnSort,
    downloadExcel,
    isLoading,
    downloadPDF,
    reportCode,
}) => {

    const size = useWindowSize();
    const reportHeader = (
        <Card className="mb-4">
            <Card.Body>
                <Container>
                    <Row>
                        <Col md={4}>
                            <span className="font-weight-bold">Date Range:</span> {DisplayDate?.startDate} to {DisplayDate?.endDate}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <span className="font-weight-bold">Total Users: {SpecificAppUsersReportData?.count?.users}</span>
                        </Col>
                        <Col md={4}>
                            <span className="font-weight-bold">No. of Phones: {SpecificAppUsersReportData?.count?.phone_devices}</span>
                        </Col>
                        <Col md={4}>
                            <span className="font-weight-bold">No. of Other Devices: {SpecificAppUsersReportData?.count?.other_devices}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <span className="font-weight-bold">App Group: {DisplayDate?.app_group_name}</span>
                        </Col>
                        <Col md={4}>
                            <span className="font-weight-bold">App package: {DisplayDate?.app_package_name}</span>
                        </Col>
                    </Row>
                </Container>
            </Card.Body>
        </Card>
    );

    if (size.width < 768) {
        return (
            <>
                {reportHeader}
                <ReactExpandableTable
                    data={SpecificAppUsersReportData?.users}
                    mobileColumns={mobileColumns}
                    removePagination={true}
                    handleColumnSort={handleColumnSort}
                    isLoading={isLoading}
                />
                <ReportFooter
                BackText={'Back'}
                 PdfText={'PDF'}
                    MailText={'Mail'}
                ExcelText={'Excel'}
                onExcelClick={downloadExcel}
                onPdfClick={downloadPDF}
                 reportTableData={SpecificAppUsersReportData?.users}
                 reportCode={reportCode}
            />
            </>
        );
    }

    return (
        <>
            <h1 className="mb-4">Specific App User Report</h1>
            {reportHeader}
            <ReactDataTable
                data={SpecificAppUsersReportData?.users}
                columns={columns}
                removePagination={true}
                handleColumnSort={handleColumnSort}
                isLoading={isLoading}
                
            />
            <ReportFooter
                BackText={'Back'}
                 PdfText={'PDF'}
                    MailText={'Mail'}
                ExcelText={'Excel'}
                onExcelClick={downloadExcel}
                 onPdfClick={downloadPDF}
                  reportTableData={SpecificAppUsersReportData?.users}
                  reportCode={reportCode}
            />
        </>
    );
}

export default SpecificAppUsersReportTable;
